export default function goBack(fallBackUrl?: string): void {
    if (document.referrer.indexOf(window.location.hostname) > -1) {
        window.history.back();
    } else if (fallBackUrl && fallBackUrl.length > 0) {
        window.location.href = fallBackUrl;
    } else {
        window.location.href = window.location.origin;
    }
}
